/* @ngInject */
function SrcDirective(CONTEXT_PATH, $log) {
    return {
        link: link,
        restrict: 'A',
        scope: {
            egSrc: '@'
        }
    };

    function link(scope, element) {
        $log.warn('The egSrc directive is deprecated. Please use the egUrl filter instead');
        element.attr('src', CONTEXT_PATH + scope.egSrc);
    }
}

angular.module('egAngularUtils').directive('egSrc', SrcDirective);